import { z } from 'zod';

export const TASK_TITLE_MAX_LENGTH = 200;
export const TASK_DESCRIPTION_MAX_LENGTH = 10_000;

/**
 * Title is required, trimmed, and non-empty after trimming; description is
 * optional and bounded. These are product-level bounds (spec.md FR-019,
 * FR-020), not framework defaults — the fields a task-creation form will ever
 * collect in this feature, per BR-002-20 in the source intent.
 */
export const taskFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'Title is required.')
    .max(
      TASK_TITLE_MAX_LENGTH,
      `Title must be ${String(TASK_TITLE_MAX_LENGTH)} characters or fewer.`,
    ),
  description: z
    .string()
    .max(
      TASK_DESCRIPTION_MAX_LENGTH,
      `Description must be ${String(TASK_DESCRIPTION_MAX_LENGTH)} characters or fewer.`,
    )
    .optional(),
});

export type TaskFormValues = z.infer<typeof taskFormSchema>;

export const TASK_FORM_DEFAULT_VALUES: TaskFormValues = {
  title: '',
  description: '',
};

/** A blank description is persisted as `null`, never as an empty string. */
export function toTaskDescription(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
}
